﻿define(['ko'], function (ko) {
    return function (price) {
        var self = this;

        self.price = price.price;
        self.grossPrice = price.grossPrice;
        self.uom = price.uom;
        self.uomDescription  = price.uomDescription;
        self.qtyModifier = price.qtyModifier;
        self.minOrderQty = price.minOrderQty;
        self.hideGrossPrice = price.hideGrossPrice;
        self.hideNetPrice = price.hideNetPrice;
        self.hidePrices = self.hideGrossPrice && self.hideNetPrice;
        
        self.displayPrice = ko.pureComputed(function () {
            var price = self.price;
            if(self.hidePrices) {
                return '-';
            }
            if(self.hideNetPrice) {
                 price = self.grossPrice;
            }
            // todo: multilanguage/locales
            return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(price);
        });
        self.displayGrossPrice = ko.pureComputed(function () {
            if(self.hideGrossPrice) {
                return '-';
            }
            // todo: multilanguage/locales
            return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(self.grossPrice);
        });

        // todo: add support for incl. tax
        self.displayVatText = ko.pureComputed(function () {
            if(self.hidePrices) {
                return '';
            }
            return 'excl. BTW';
        });
    };
});
